import React from "react";
import { ListGroupItem, ListGroup, Row, Col, Grid, FormGroup, Form, FormControl, ControlLabel, Checkbox, MenuItem, DropdownButton, ButtonToolbar, Button,Tab,NavItem,Nav } from 'react-bootstrap'
import Features from "../Features/Features";
import Breadcrumbing from "../Breadcrumbing/Breadcrumbing";
import UserSetting from "../UserSetting/UserSetting";
class AddPayment extends React.Component {
render() {
return (
<Grid>




    <div className="Add-payment__method">
        <Row>
            <UserSetting />
            <div className="text">
            <Col md={9}>
            <div className="payment__method-bg">
            <div>
                <div className="Payment__methods__title">
                    <h3> Add Payment Method</h3>
                </div>
             
               
                <hr className="Payment__methods-hr"/>
            </div>
            <Row>
            <Col md={8} mdOffset={2}>

              

                            <div className="checkout-title">
                                
                            

 <Tab.Container id="left-tabs-example" defaultActiveKey="first">
  <Row>
    <Col sm={12}>
      <Nav bsStyle="pills" stacked>
        <NavItem eventKey="first">  
         <img title="1" src={require("../../img/checkout/credit.png")} />
<p> Credit Card </p></NavItem>
        <NavItem eventKey="second"><img title="1" src={require("../../img/checkout/paypal.png")} />
<p>paypal</p></NavItem>


   <NavItem eventKey="third"><img title="1" src={require("../../img/payment/cashondelevry.png")} />
<p>Cash On Delivery </p></NavItem>
      </Nav>
      
    </Col>
    <Row>
    <Col sm={12}>
      <Tab.Content animation>
      <hr/>

        <Tab.Pane eventKey="first">
        
     
                                        <Col md={12}>

                                            <FormGroup controlId="formHorizontalEmail">

                                                <FormControl type="text" placeholder="Card Number" />
                                            </FormGroup>
                                        </Col>
                                        <Col md={9}>

                                            <FormGroup controlId="formHorizontalEmail">

                                                <FormControl className="card-Holder" type="text" placeholder="Card Holder*" />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3}>

                                            <FormGroup controlId="formHorizontalEmail">

                                                <FormControl className="user-cvv" type="text" placeholder="CVV*" />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>

                                            <DropdownButton title="Expire Month" id="ExpireMonth">
                                                <MenuItem eventKey="1">Action</MenuItem>
                                                <MenuItem eventKey="2">Another action</MenuItem>
                                                <MenuItem eventKey="3">Something else here</MenuItem>
                                                <MenuItem divider />
                                                <MenuItem eventKey="4">Separated link</MenuItem>
                                            </DropdownButton>
                                        </Col>

                                        <Col md={6}>

                                            <DropdownButton title="Expire Year" id="ExpireYear">
                                                <MenuItem eventKey="1">Action</MenuItem>
                                                <MenuItem eventKey="2">Another action</MenuItem>
                                                <MenuItem eventKey="3">Something else here</MenuItem>
                                                <MenuItem divider />
                                                <MenuItem eventKey="4">Separated link</MenuItem>
                                            </DropdownButton>
                                        </Col>
                                        <Col md={12}>
                                        <div className="checkout-payment">
                                            <img src={require("../../img/checkout/payment.png")} />
</div>
                                        </Col>
                                        
                                        </Tab.Pane>
        <Tab.Pane eventKey="second">Tab 2 content </Tab.Pane>

           <Tab.Pane eventKey="third">Tab 3 content</Tab.Pane>

      </Tab.Content>
      <Col md={12}>

 
</Col>
    </Col>
    </Row>
 
 
  </Row>



</Tab.Container>

                            </div>
                            
                                 <div className="Add-payment__method-buttons">
    <span><a href="#"><button type="button" className="Add-payment__method btn ">Add Payment Method</button></a> </span>
       
      <span> <a href=""><button type="button" className="Add-payment__cancel-process btn">Cancel Process</button></a> </span>
</div>
                            </Col>
                            </Row>

                        </div>

            </Col>
            </div>
        </Row>
        <hr/>
    </div>
    <Features/>
</Grid>

);
}
}
export default AddPayment;


// WEBPACK FOOTER //
// ./src/Components/AddPayment/AddPayment.jsx